import { Button } from "@/components/ui/button";
import { DialogDescription, DialogFooter, DialogHeader } from "@/components/ui/dialog"
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"
import { noop } from ".";
import { useState } from "react";

export interface IModalProps {
  toggle: () => void,
  exibir: boolean,
  titulo: string,
  conteudo: string[],
  acaoConfirmacao(): void,
}

const InserirCreditosModal = ({ toggle, exibir, titulo, conteudo, acaoConfirmacao }: IModalProps) => {
  const funcaoValida = acaoConfirmacao && acaoConfirmacao !== noop;
  const [loading, setLoading] = useState(false);

  async function handleConfirmar() {
    try {
      setLoading(true)
      await acaoConfirmacao()
      toggle();
    } catch (error) {

    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={exibir} onOpenChange={toggle}>
      <DialogContent>
        <DialogDescription className="hidden">
          {titulo}
        </DialogDescription>
        <DialogHeader onClick={() => toggle()}>
          <DialogTitle className='text-xl font-semibold uppercase'>{titulo}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 p-5 font-normal">
          <ul className="list-decimal text-justify">
            {conteudo.map((texto, i) => <li key={`${titulo.replace(/ /g, "_")}_${i + 1}`}>{texto}</li>)}
          </ul>
        </div>
        <DialogFooter>
          <Button disabled={loading} type="button" onClick={() => toggle()} variant="outline" className="m-1">Fechar</Button>
          {
            funcaoValida && <Button disabled={loading} type="submit" onClick={handleConfirmar} className="m-1">
              {
                loading ? (<>Aguarde...</>) : (<>Confirmar</>)
              }
            </Button>
          }
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default InserirCreditosModal;